module.exports = __webpack_public_path__ + "static/img/Carts-active.18af6b54.svg";